import { render } from "./econsScreen.vue?vue&type=template&id=7e767770"
import script from "./econsScreen.vue?vue&type=script&lang=js"
export * from "./econsScreen.vue?vue&type=script&lang=js"

import "./econsScreen.vue?vue&type=style&index=0&id=7e767770&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__